import { Component, OnInit,TemplateRef } from '@angular/core';
import {FormGroup,FormControl,Validators} from '@angular/forms';
import { LoadService } from '../../services/load.service';
import { PackingEcService } from '../../services/packingec.service';
import { PalletsService } from '../../services/pallets.service';
import { OrdensalidaService } from '../../services/ordensalida.service';
import { TagsService } from '../../services/tags.service';
import { StockService } from '../../services/stock.service';
import { AreasService } from '../../services/areas.service';
import { ProductsService } from '../../services/products.service';
import { OrderstatusService } from '../../services/orderstatus.service';
import { ClientsService } from '../../services/clients.service';
import * as moment from 'moment';
import { FilterUrlService } from '../../services/filter-url.service';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {Router} from '@angular/router';


@Component({
  selector: 'app-solicitudmovimiento',
  templateUrl: './solicitudmovimiento.component.html',
  styleUrls: ['./solicitudmovimiento.component.css']
})
export class SolicitudmovimientoComponent implements OnInit {
  public signupFormBuscar:FormGroup;
  public solicitudForm:FormGroup;
  public orders:any[];
  public estados:any[];
  public salidas:any[];
  public areas:any[];
  public clientes:any[];
  public productos:any[];
  public pallets:any[];
  public cajas:any[];
  public alert:string;
  public isopen:boolean;
  public mostrartabla:boolean;
  public totalcajas:number;
  public stock_list:any[];
  public links: any;
  public meta: any;
  public filters:string;
  public modalRef: BsModalRef;
  public modalRef2:BsModalRef;
  public modalRef3:BsModalRef;
  public orden_aprobar:any;
  public orden_enviar:any;
  public bloquearCrearSolicitud:boolean;
  // public settings = {
  //   columns:{
  //     pr_code: {
  //       header: "Producto",
  //       type: "obj",
  //       filter: { visible:true,  id_type:'number', default:'asc', type:'dd' },
  //     },
  //     pr_description:{
  //       header:"Descripción",
  //       type:"text",
  //       filter:{visible:true}
  //     },
  //     pr_group:{
  //       header:"Grupo",
  //       type:"text",
  //       filter:{visible:true}
  //     },
  //     lot_code: {
  //       header: "Lote",
  //       type:"text",
  //       filter: { visible:true }
  //     },
  //     elaboration_date: {
  //       header: "Fecha Congelación",
  //       type:"date",
  //       filter: { visible:true }
  //     }
  //   },
  //   actions:{
  //     edit: false,
  //     view: false,
  //     delete: false,
  //     close:false,
  //     select:true
  //   }
  // };

  public settings = {
    columns:{
      id: {
        header: "Número",
        type: "number",
        tipo:"id",
        path:"id",
        filter:{visible:true, id_type:'number', default:'desc',type:'text'}
      },
      area_id: {
        header: "Area",
        type: "obj",
        tipo:"areas",
        path:"relationships.area.data.attributes.name",
        filter: { visible:true,  id_type:'number', default:'asc', type:'dd' },
      },
      client_id: {
        header: "Cliente",
        type: "obj",
        tipo:"cliente",
        path:"relationships.client.data.attributes.name",
        filter: { visible:true,  id_type:'number', default:'asc', type:'dd' },
      },
      reason_id: {
        header: "Motivo Salida",
        type: "obj",
        tipo:"motivo",
        path:"relationships.reason.data.attributes.name",
        filter: { visible:false,  id_type:'number', default:'asc', type:'dd' },
      },
      status_id:{
        header:"Estado Solicitud",
        type:"obj",
        tipo:"status orden",
        path:"relationships.status.data.attributes.name",
        filter: { visible:true,  id_type:'number', default:'asc', type:'dd' },
      },
      approver_id:{
        header:"N° Comentarios",
        type:"obj",
        tipo:"num_comentarios",
        path:"attributes.count_messages",
        filter:{visible:false,default:'asc'}
      },
      receptor_id:{
        header:"Total Cajas",
        type:"obj",
        tipo:"num_cajas",
        path:"attributes.total_box",
        filter:{visible:false,default:'asc'}
      },
      weight:{
        header:"Total (Kg)",
        type:"obj",
        tipo:"kilos_cajas",
        path:"attributes.kg",
        filter:{visible:false,default:'asc'}
      }
    },
    actions:{
      edit: false,
      view: true,
      delete: false,
      close:false,
      select:false,
      editOrder:true,
      sendOrder:true,
      approveOrder:true,
      pdf:true
    }
  };

  constructor(private _loaddata:LoadService,
              private _palletsService:PalletsService,
              private _tagsService:TagsService,
              private _stockService:StockService,
              private _packingecService:PackingEcService,
              private _areasService:AreasService,
              private _productsService:ProductsService,
              private _filter: FilterUrlService,
              private _localeService:BsLocaleService,
              private _modalService:BsModalService,
              private _ordenSalida:OrdensalidaService,
              private _orderStatus:OrderstatusService,
              private route:Router,
              private _clientsService:ClientsService) {

    this.signupFormBuscar = new FormGroup({
      'producto':new FormControl('', Validators.required),
      'lote': new FormControl(''),
      'grupo': new FormControl(''),
      'fecha':new FormControl(''),
      'descripcion':new FormControl('')
    });

    this.solicitudForm = new FormGroup({
      'reason_id': new FormControl('',Validators.required),
      'client_id': new FormControl('',Validators.required)
    });

    this.bloquearCrearSolicitud = false;
   }

  ngOnInit() {
    /*comprobando permisos*/
    let continuar = false;
    let roles = JSON.parse(localStorage.getItem('roles'));
    for(let rol of roles){
      if(rol.attributes.name === 'Camara'){
        this.bloquearCrearSolicitud = true;
      }
      if(rol.attributes.name === 'Gerente Planta' || rol.attributes.name === 'Desarrollo' || rol.attributes.name === 'Control de calidad' || rol.attributes.name === 'Camara'){
        continuar = true;
      }
    }
    if(continuar){
      /*para dejar en español el datepicker*/
      this._localeService.use('es');
      this.orders = [];
      this.estados = [];
      this.filters = '';
      this.salidas = [];
      this.areas = [];
      this.productos = [];
      this.pallets = [];
      this.cajas = [];
      this.stock_list = [];
      this.alert = '';
      this.isopen = false;
      this.mostrartabla = false;
      this.totalcajas = 0;
      this.solicitudForm.valueChanges.subscribe(data=>{
        console.log("Form Solicitud: ",this.solicitudForm);
      });
      this.signupFormBuscar.valueChanges.subscribe(data=>{
        console.log("Form Busqueda: ", this.signupFormBuscar);
      });
      this._filter.filterFirstLoad(this.settings);

      this.loadStatus();
      this.loadSalidas();
      this.loadOrders();
      this.loadClientes();
      //this.loadAreas();
    }
    else{
      this.route.navigate(['/']);
    }

  }

  loadClientes(){
    this._clientsService.getAll().subscribe((response:any)=>{
      this.clientes = response.data;
      let data = this.clientes;
      console.log("Clientes: ",this.clientes);
      let clientes:string = "{";
            for (var key in data) {
              //console.log("KEY: ", key);
              if (data.hasOwnProperty(key)) {
                clientes+='"'+data[key].id+'":"'+data[key].attributes.name+'",';
              }
            }
            clientes = clientes.slice(0,-1);
            clientes+="}";
            this.settings.columns.client_id.filter['data'] = clientes;
      console.log("Clientes: ",this.clientes);
    },error=>{
      console.log("Error, no se cargaron los clientes.",error.error.error);
    })
  }

  loadOrders(){
    this.alert = 'Cargando Ordenes de Salida...';
    this.isopen = true;
    this._loaddata.loadChange(40);
    this._ordenSalida.getAll().subscribe((response:any)=>{
      this.orders = response.data;
      console.log("ORDENES DE SALIDA: ", this.orders);
      for(let order of this.orders){
        if(order.relationships.messages.data.length == 0){
          order.attributes.count_messages = 'S/C';
        }
        if(order.relationships.tags.data.length == 0){
          order.attributes.total_box = '0';
          order.attributes.kg = '0';
        }
        else{
          order.attributes.total_box = order.relationships.tags.data.length;
        }
      }
      this.meta = response.meta;
      this.links = response.links;
      console.log("Ordenes: ", this.orders);
      this.alert = 'Carga Completa de Ordenes de Salida.'
      this.isopen = true;
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();
      //this.loadSalidas();
    },error=>{
      console.log("ERROR CARGAR ORDENES: ", error.error.error);
      this.alert = 'No se han podido cargar las ordenes de salida.'
      this.isopen = true;
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();
    })
  }

  loadSalidas(){
    this.alert = "Cargando motivos de salidas.";
    this.isopen = true;
    this._loaddata.loadChange(40);

    this._stockService.getStockExitReasons().subscribe(
      (response:any) => {
        console.log("razones: ", response.data);
        let op = false;
        for(let razon of response.data){
          if(razon.id != 8 && razon.id != 9 && razon.id != 14 && razon.id != 15 && razon.id != 20 && razon.id != 21 && razon.id != 22){

            this.salidas = [...this.salidas,{'id':razon.id,'name':razon.attributes.name}];
          }
        }
        this.alert = "Motivos de Salida Cargados.";
        this.isopen = true;
        this._loaddata.loadChange(100);
        //this.loadAreas();
      },
      (error) => {
        console.log('ERROR: ',error.error.error);
      }
    );
  }

  loadAreas(){
    this.alert = "Cargando Areas."
    this.isopen = true;
    this._loaddata.loadChange(40);

    this._areasService.getAll().subscribe((response:any)=>{
        this.areas = response.data;
        let data = this.areas;
        console.log("AREAS: ",this.areas);
        let areas:string = "{";
              for (var key in data) {
                //console.log("KEY: ", key);
                if (data.hasOwnProperty(key)) {
                  areas+='"'+data[key].id+'":"'+data[key].attributes.name+'",';
                }
              }
              areas = areas.slice(0,-1);
              areas+="}";
              this.settings.columns.area_id.filter['data'] = areas;
        this.alert = "Areas Cargadas."
        this.isopen = true;
        this._loaddata.loadChange(100);
        this.onClosedAutomatic();
        //this.loadProducts();
        //this.getProductos();
    },error=>{
      console.log("ERROR: ", error.error.error);
    });
  }

  loadStatus(){
     this._orderStatus.getAll().subscribe((response:any)=>{
       let data = response.data;
       console.log("EStados Ordenes: ",response.data);
       let status:string = "{";
             for (var key in data) {
               //console.log("KEY: ", key);
               if (data.hasOwnProperty(key)) {
                 status+='"'+data[key].id+'":"'+data[key].attributes.name+'",';
               }
             }
             status = status.slice(0,-1);
             status+="}";
             this.settings.columns.status_id.filter['data'] = status;
     },error=>{
       console.log("No se han cargado el estado de las ordenes: ",error.error.error);
     })
  }

  editarOrden(id:number){
    console.log("ID ORDEN: ",id);
     this.route.navigate(['/solicitud/editar/', id]);
  }

  onClosedAutomatic(){
    setTimeout(()=>{
      this.isopen = false;
      this.alert = '';
    },3000)
  }

  onClosed(){
    this.isopen = false;
  }





  loadProducts(){
    this.alert = "Cargando Productos";
    this.isopen = true;
    this._loaddata.loadChange(80);

    this._productsService.getAll().subscribe((response:any)=>{
      this.productos = response.data;
      console.log("PRODUCTOS: ", this.productos);
      this.alert = "Productos Cargados";
      this.isopen = true;
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();
    },error=>{
      console.log("ERROR: ", error.error.error);
    })
  }

  formatearFecha(){
    console.log("SI");
    let date = this.signupFormBuscar.get('fecha').value;
    this.signupFormBuscar.setValue({
      'fecha' : this.transformDates(date)
    });
  }

  transformDates(fecha:Date):String{
    let fech = moment(fecha);
    //2018-02-28 00:00:00
    return (fech.year()+'-'+(fech.month()+1)+'-'+fech.date()+' 00:00:00');
  }

  buscarStock(){
    this.stock_list = [];
    let producto = this.signupFormBuscar.get('producto').value;
    let grupo = this.signupFormBuscar.get('grupo').value;
    let lote = this.signupFormBuscar.get('lote').value;
    let fecha = this.signupFormBuscar.get('fecha').value;
    let descripcion = this.signupFormBuscar.get('descripcion').value;
    this.filters = '?sort=++pr_code,++lot_code,++elaboration_date,++pr_description,++pr_group';
    let fil1= '';
    let fil2= '';
    let fil3= '';
    let fil4= '';
    let fil5= '';
    let fecha2,fecha3,dia,mes,ano,arrayFecha,finalfecha;


    if(producto != ''){
      fil1 = `&pr_code=><${producto}`;
    }

    if(lote != ''){
      fil2 = `&lot_code=><${lote}`;
    }

    if(fecha != ''){
      fecha = this.transformDates(fecha);
      fecha2 = fecha.split(' ');
      fecha3 = fecha2[0];
      arrayFecha = fecha3.split('-');
      dia = arrayFecha[2];
      mes = arrayFecha[1];
      ano = arrayFecha[0];
      console.log("FECHA: ", dia,mes,ano);
      if(mes == 1 || mes == 2|| mes == 3 || mes == 4 || mes == 5 || mes == 6 || mes == 7  || mes == 8 || mes === 9){
        mes = '0'+mes;
      }
      if(dia == 1 || dia == 2|| dia == 3 || dia == 4 || dia == 5 || dia == 6 || dia == 7  || dia == 8 || dia === 9){
        dia = '0'+dia;
      }
      finalfecha = ano+'-'+mes+'-'+dia;
      fil3 = `&elaboration_date=><${finalfecha}`;
    }

    if(descripcion != ''){
      fil4 = `&pr_description=><${descripcion}`;
    }

    if(grupo != ''){
      fil5 = `&pr_group=><${grupo}`;
    }

    this.filters+=fil1+fil2+fil3+fil4+fil5;
    console.log('FILTROS Busqueda: ',this.filters);
    this._loaddata.loadChange(40);
    this.alert = "Buscando Resultados..."
    this.isopen =true;
    this._stockService.getDataFiltered(this.filters).subscribe((response:any)=>{
      console.log("RES BUSQUEDA: ", response);
      this.stock_list = response.data;
      this.links = response.links;
      this.meta = response.meta;
      this._loaddata.loadChange(100);
      this.alert = "Carga Correcta."
      this.isopen =true;
      this.onClosedAutomatic();
    },error=>{
      console.log("ERROR: ", error.error.error);
    })

    console.log("DATOS FORM ", producto,fecha3,lote,grupo,descripcion);

  }


  updateData(response:any){
    console.log("Respuesta Actualización: ", response);
    this.orders = response.data;
    for(let order of this.orders){
      if(order.relationships.messages.data.length == 0){
        order.attributes.count_messages = 'S/C';
      }
      if(order.relationships.tags.data.length == 0){
        order.attributes.total_box = '0';
        order.attributes.kg = '0';
      }
      else{
        order.attributes.total_box = order.relationships.tags.data.length;
      }
    }
    this.meta = response.meta;
    this.links = response.links;
    // for(let c of this.stock_list){
    //   c.attributes.select = false;
    // }
    //this.stock_list = this.formatDate(this.stock_list);
    // this.stock_list = data;
    // let suma = 0;
    //console.log("Datos de Actualizacion de Pagina: ", data.attributes.total);
    // for(let item of this.stock_list){
    //        suma = suma + item.attributes.total;
    // }
    // this.total_paginate = suma;
    //console.log("Respuesta de la paginacion de Stock: ", response);
  }


  /*formatea la fecha*/
  formatDate(stock_list:any){
    for(let stock of stock_list){
      let fecha = stock.attributes.created_at.date;
      let fechArray = fecha.split(' ');
      let fecha2 = fechArray[0];
      let fechArray3 = fecha2.split


      stock.attributes.created_at = fecha2;
    }
    return stock_list;
  }

  // getProductos(){
  //   this.alert = 'Cargando Productos.';
  //   this.isopen = true;
  //   this._loaddata.loadChange(80);
  //
  //   this._productsService.getAll().subscribe(
  //     (response:any) => {
  //       let data = response.data;
  //       //console.log("DATA: ",data);
  //       let products:string = "{";
  //       for (var key in data) {
  //         //console.log("KEY: ", key);
  //         if (data.hasOwnProperty(key)) {
  //           products+='"'+data[key].attributes.code+'":"'+data[key].attributes.code+'",';
  //         }
  //       }
  //       products = products.slice(0,-1);
  //       products+="}";
  //       this.settings.columns.pr_code.filter['data'] = products;
  //       this.alert = "Productos Cargados";
  //       this.isopen = true;
  //       this.mostrartabla = true;
  //       this._loaddata.loadChange(100);
  //       this.onClosedAutomatic();
  //     },
  //     (error) => {
  //       console.log("Error: ", error.error.error);
  //     }
  //   );
  // }

  /*busca los datos con respecto a los filtros seleccinados*/
  loadDataFiltered(filters){
    console.log('FILTROS: ', filters);
    this.isopen = false;
    this._loaddata.loadChange(50);
    this._ordenSalida.getDataFiltered(filters).subscribe(
      (response:any) => {
        console.log("Respuesta del filtro", response);
        this.orders = response.data;
        for(let order of this.orders){
          if(order.relationships.messages.data.length == 0){
            order.attributes.count_messages = 'S/C';
          }
          if(order.relationships.tags.data.length == 0){
            order.attributes.total_box = '0';
            order.attributes.kg = '0';
          }
          else{
            order.attributes.total_box = order.relationships.tags.data.length;
          }
        }
        // for(let c of this.stock_list){
        //   c.attributes.select = false;
        // }
        // this.stock_list = this.formatDate(this.stock_list);
        this.links = response.links;
        this.meta = response.meta;

        this._loaddata.loadChange(100);
        this.alert = "Carga Correcta."
        this.isopen =true;
        this.onClosedAutomatic();
      },
      (error) => {
        if(error.status == 0){
          this.alert = 'Busqueda sin resultados.';
          this.onClosedAutomatic();
        }
        else{
          console.log("ERROR: ",error.error.error);
        }
      }
    );
  }

  agregarCaja(caja){
    let c = this.stock_list[caja.index];
    c.attributes.select = true;
    this.cajas.push(c);
    console.log("cajas agregar: ", this.cajas);
  }

  quitarCaja(caja){


    let c = this.stock_list[caja.index];
    let caj = this.cajas.filter(function(ca) {
           return ca.id == c.id;
         })[0];

    console.log("CAJA REsultado: ", caj);
    console.log("CAJA RECIBIDA: ", caja);
    c.attributes.select = false;
    console.log("cajas quitar: ", this.cajas);
  }

  mostrarModalSolicitud(template: TemplateRef<any>) {
    //console.log("ASI");
    this.modalRef = this._modalService.show(template);
  }

  cerrarModalSolicitud(){
    this.modalRef.hide();
  }

  crearSolicitud(){
    let reason_id = this.solicitudForm.get('reason_id').value;
    let client_id = this.solicitudForm.get('client_id').value;
    let data = {
      'reason_id':reason_id,
      'client_id':client_id
    }

    // let token = localStorage.getItem("id_token");
    // console.log("token: ", token);
    console.log("data: ", data);
    this.alert = 'Creando la Nueva Orden de Salida';
    this.isopen = true;
    this._loaddata.loadChange(40);

    let body = this._ordenSalida.transformData(data);
    console.log("BODY: ", body);
    this._ordenSalida.save(body).subscribe((response:any)=>{
      console.log("Respuesta creación orden: ", response);
      this.alert = 'Orden de Salida Creada';
      this.isopen = true;
      this._loaddata.loadChange(100);
      this.limpiarFormulario();
      this.cerrarModalSolicitud();
      this.loadOrders();

    },error=>{
      console.log("ERROR CREAR ORDEN: ", error.error.error);
      this.alert = 'No se ha podido crear la solicitud';
      this.isopen = true;
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();
    })
  }

  limpiarFormulario(){
    this.solicitudForm.reset();
    this.solicitudForm.setValue({
      'reason_id':'',
      'client_id':''
    });
  }

  verDetalleSolicitud(index:number){
    let orden = this.orders[index];
    console.log("Orden: ", orden);
    this.route.navigate(['/solicitud/detalle',orden.id]);
  }

  enviarOrden(id:number){
    console.log("Orden a Enviar: ", id);
    let body = this._ordenSalida.transformDataUpdateStatusToRevision(id);
    this._ordenSalida.updateStateToRevision(body,id).subscribe((response:any)=>{
      console.log("respuesta: ", response);
      this.cerrarModalEnviar();
      this.loadOrders();
    },error=>{
      console.log("No se ha podido enviar la orden: ", error.error.error);
    });
  }

  mostrarConfirmacion(item:any,template: TemplateRef<any>){
    console.log("Orden a Aprobar: ", item);
    this.orden_aprobar = item.item;
    this.modalRef2 = this._modalService.show(template);
  }

  cerrarModalAprobar(){
    this.modalRef2.hide();
  }

  aprobarOrden(id){
    console.log("id: ",id);
    this.alert = 'Aprobando Orden...';
    this.isopen = true;
    this._loaddata.loadChange(40);
    let body = this._ordenSalida.transformDataUpdateStatusToApprovated(id);
    console.log("Body aprobar: ", body);
    this._ordenSalida.updateStateToApprovated(body,id).subscribe((response:any)=>{
      this.orden_aprobar = response;
      this.alert = 'Orden Aprobada.';
      this.isopen = true;
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();
      this.cerrarModalAprobar();
      this.loadOrders();
      console.log("response aprobación: ",response);
    },error=>{
      this.alert = `No se ha aprobado la orden. ERROR: ${error.error.error}`;
      this.isopen = true;
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();
      console.log("no se ha aprobado la orden: ", error.error.error);
    })
  }

  mostrarEnviarOrden(orden,template:TemplateRef<any>){
    this.orden_enviar = orden.item;
    this.modalRef3 = this._modalService.show(template);
  }

  cerrarModalEnviar(){
    this.modalRef3.hide();
  }

  openPDF(order:any){
    console.log('orden',order);
    let url = order.attributes.pdf_url;
    window.open(url, '_blank');
  }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/solicitudmovimiento/solicitudmovimiento.component.ts